import { render, staticRenderFns } from "./LayoutFourth.vue?vue&type=template&id=ba95aebc"
import script from "./LayoutFourth.vue?vue&type=script&lang=js"
export * from "./LayoutFourth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports